import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, withKeys as _withKeys, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "Toolbar" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "ToolbarTitle" }, "Scholarships", -1 /* HOISTED */)
const _hoisted_3 = { class: "Navigation" }
const _hoisted_4 = { class: "Search" }
const _hoisted_5 = { class: "SearchDescription" }
const _hoisted_6 = { class: "Jump" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "lnr-chevron-right" }, null, -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode(_component_el_button, {
        class: "ToolbarActions ChampionButton CreateNew",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toCreateScholarship()))
      }, {
        default: _withCtx(() => [
          _createTextVNode("Create new")
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.searchDescription), 1 /* TEXT */)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.jumpTargetId,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.jumpTargetId) = $event)),
              placeholder: "Scholarship ID",
              class: "Input",
              onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (_ctx.jump()), ["enter"]))
            }, null, 8 /* PROPS */, ["modelValue"]),
            _createVNode(_component_el_button, {
              class: "NavigationActionInline",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.jump()))
            }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        })
      ])
    ]),
    _createVNode(_component_el_table, {
      data: _ctx.scholarships,
      stripe: "",
      border: "",
      class: "full-width"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "id",
          label: "Scholarship ID"
        }, {
          default: _withCtx((scope) => [
            _createVNode(_component_el_button, {
              link: "",
              type: "primary",
              onClick: ($event: any) => (_ctx.toEditScholarship(scope.row))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(scope.row.id), 1 /* TEXT */)
              ]),
              _: 2 /* DYNAMIC */
            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"])
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(_component_el_table_column, {
          prop: "title",
          label: "Title"
        }, {
          default: _withCtx((scope) => [
            _createVNode(_component_el_button, {
              link: "",
              type: "primary",
              onClick: ($event: any) => (_ctx.toEditScholarship(scope.row))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(scope.row.title), 1 /* TEXT */)
              ]),
              _: 2 /* DYNAMIC */
            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"])
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(_component_el_table_column, {
          prop: "formattedDestinationCountries",
          label: "Destination countries"
        }),
        _createVNode(_component_el_table_column, {
          prop: "formattedProvider",
          label: "Provider ID"
        }),
        _createVNode(_component_el_table_column, {
          prop: "formattedTimestampModified",
          label: "Date modified"
        })
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["data"])
  ], 64 /* STABLE_FRAGMENT */))
}